import AtlasSdk from '@atlas/sdk';
import { IToastConfig } from '@atlas/sdk/lib/namespaces/toast/toast.types';
import {
  showCustomNotification,
  clearCustomNotification,
  CustomNotificationOptionsParams,
} from './custom-notification';

const DEFAULT_TOAST_PROPS = { dismissible: true, dismissDelay: AtlasSdk.toast.delays.MEDIUM };

const showInfoToast = async (content: IToastConfig | string) => {
  const result = typeof content === 'string' ? { message: content } : content;

  const toast = {
    ...DEFAULT_TOAST_PROPS,
    type: AtlasSdk.toast.types.INFO,
    ...result,
  };
  await toastNotification(toast);
};

const showSuccessToast = async (content: IToastConfig | string) => {
  const result = typeof content === 'string' ? { message: content } : content;

  const toast = {
    ...DEFAULT_TOAST_PROPS,
    type: AtlasSdk.toast.types.SUCCESS,
    ...result,
  };
  await toastNotification(toast);
};

const showDangerToast = async (content: IToastConfig | string) => {
  const result = typeof content === 'string' ? { message: content } : content;

  const toast = {
    ...DEFAULT_TOAST_PROPS,
    type: AtlasSdk.toast.types.DANGER,
    ...result,
  };
  await toastNotification(toast as IToastConfig);
};

const showWarningToast = async (content: IToastConfig | string) => {
  const result = typeof content === 'string' ? { message: content } : content;

  const toast = {
    ...DEFAULT_TOAST_PROPS,
    type: AtlasSdk.toast.types.WARNING,
    ...result,
  };
  await toastNotification(toast as IToastConfig);
};

const toastNotification = async (toast: IToastConfig) => {
  await AtlasSdk.toast.show({ ...toast });
};

const notification = {
  info: showInfoToast,
  success: showSuccessToast,
  error: showDangerToast,
  warning: showWarningToast,
  custom: {
    info: ({ config, foreverShowLast = false }: CustomNotificationOptionsParams) => {
      showCustomNotification({ config: { ...config, type: AtlasSdk.toast.types.INFO }, foreverShowLast });
    },
    warning: ({ config, foreverShowLast = false }: CustomNotificationOptionsParams) => {
      showCustomNotification({ config: { ...config, type: AtlasSdk.toast.types.WARNING }, foreverShowLast });
    },
    danger: ({ config, foreverShowLast = false }: CustomNotificationOptionsParams) => {
      showCustomNotification({ config: { ...config, type: AtlasSdk.toast.types.DANGER }, foreverShowLast });
    },
    success: ({ config, foreverShowLast = false }: CustomNotificationOptionsParams) => {
      showCustomNotification({ config: { ...config, type: AtlasSdk.toast.types.SUCCESS }, foreverShowLast });
    },
    clearAll: clearCustomNotification,
  },
};

export default notification;
